import { useEffect, useState } from 'react'
import reactImageSize from 'react-image-size'

export const useImageSizeV2 = (url: string) => {
  const [result, setResult] = useState<{
    ratio: number
    isLandscape: boolean
  }>({
    ratio: 0,
    isLandscape: false,
  })

  useEffect(() => {
    if (!url) return

    const execute = async () => {
      try {
        const { width, height } = await reactImageSize(url)
        setResult({
          isLandscape: width > height,
          ratio: width / height,
        })
      } catch (e) {
        console.log(
          `Unable to get image size result from the loaded url due to ${e}`
        )
      }
    }

    execute()
  }, [url])

  return result
}
